// extracted by mini-css-extract-plugin
module.exports = {"filterContainer":"HospitalClaimScreen_filterContainer__2OOXE","filter":"HospitalClaimScreen_filter__1oHAh","hospitalClaimHeader":"HospitalClaimScreen_hospitalClaimHeader__3CsSB"};